import { render, staticRenderFns } from "./r-trigger-order.vue?vue&type=template&id=ff919188&scoped=true"
import script from "./r-trigger-order.vue?vue&type=script&lang=js"
export * from "./r-trigger-order.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-order.vue?vue&type=style&index=0&id=ff919188&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff919188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff919188')) {
      api.createRecord('ff919188', component.options)
    } else {
      api.reload('ff919188', component.options)
    }
    module.hot.accept("./r-trigger-order.vue?vue&type=template&id=ff919188&scoped=true", function () {
      api.rerender('ff919188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-order.vue"
export default component.exports